var defaultAlpha = 0; //此参数用于页面加载时用户当前角度用于后续计算偏移量
var firstInit = false;
function askDeviceOrientationPermission() {
  if (typeof DeviceOrientationEvent.requestPermission == 'function') {
    //iOS 13 需要授权
    window.moo.$bus.$emit('rocket:device:orientation:requestPermission');
    document.addEventListener(
      'click',
      () => {
        DeviceOrientationEvent.requestPermission()
          .then((response) => {
            if (response == 'granted') {
              //授权成功
              window.moo.$bus.$emit('rocket:device:orientation:granted');
            } else {
              //授权失败
              window.moo.$bus.$emit(
                'rocket:device:orientation:denied',
                '请求授权被拒绝'
              );
            }
          })
          .catch((e) => {
            window.moo.$bus.$emit(
              'rocket:device:orientation:denied',
              '请求授权报错'
            );
          });
      },
      {
        once: true,
      }
    );
  } else {
    //未触发重力感应 又没有授权
    //判断 iOS12.2-13之间版本
    window.moo.$bus.$emit(
      'rocket:device:orientation:denied',
      '请在设置中打开动作与方向访问'
    );
  }
}

function initDeviceOrientationEvent(cb) {
  if (window.DeviceOrientationEvent) {
    // 第一次注册事件时执行
    if (!firstInit) {
      let timer;
      // iOS 可能需要授权
      if (window.moo.CONSTANT.IS_MOBILE && window.moo.CONSTANT.IS_IOS) {
        timer = setTimeout(askDeviceOrientationPermission, 100);
      }
      window.addEventListener(
        'deviceorientation',
        (e) => {
          if (timer) {
            clearTimeout(timer); // 已经授权过，取消授权
          }
          // 记录一下初始方向
          // 安卓的 alpha 角度是从北极方向开始计算
          defaultAlpha = e.alpha;
        },
        { once: true }
      );
    }
    window.addEventListener('deviceorientation', (e) => {
      let alpha = e.alpha - defaultAlpha; // 0  - 360
      // if (e.webkitCompassHeading) alpha = e.webkitCompassHeading;
      // else alpha = e.alpha;
      if (alpha < 0) alpha = 360 + alpha;
      else if (alpha > 360) alpha = alpha - 360;

      let beta = e.beta;
      let gamma = e.gamma;
      cb(beta, gamma, alpha);
    });
  }
  firstInit = true;
}

export { initDeviceOrientationEvent };
